import React, { useState } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import map from 'lodash/map';
import { Button, Image } from 'shared/lib/SureDesignSystem';
import styles from './Hero.module.css';
import useInterval from './utils';
import heroSrc1 from './assets/sdk.png';
import heroSrc1Webp from './assets/sdk.webp';
import { isWebPSupported } from 'shared/lib/utils';

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(1);

  const heroImages = [
    {
      id: 1,
      title: 'SDK',
      url: heroSrc1,
      urlWeb: heroSrc1Webp,
    },
  ];

  useInterval(() => {
    const isLastImage = currentImage === heroImages.length;
    setCurrentImage(isLastImage ? 1 : currentImage + 1);
  }, 5000);

  return (
    <div
      className={classnames(
        styles.heroSection,
        isWebPSupported
          ? styles.heroSectionBackgroundWebp
          : styles.heroSectionBackground
      )}
    >
      <div className={styles.container}>
        <div className={styles.left}>
          <h2 className={styles.eyebrow}>Affinity Partners & ECOMMERCE</h2>
          <h1 className={styles.title}>
            Insurance is complex. We make it simple.
          </h1>
          <p className={styles.description}>
            SURE Connect simplifies embedding insurance natively into any
            digital property or mobile app.
          </p>
          <Link to="/contact">
            <Button secondary className={styles.button}>
              CONTACT PARTNERSHIPS
            </Button>
          </Link>
        </div>

        <div className={styles.imageWrap}>
          {map(heroImages, ({ id, url, urlWebp, title }) => (
            <Image
              className={classnames(styles.image, {
                [styles.fadeIn]: currentImage === id,
              })}
              key={id}
              src={url}
              webp={urlWebp}
              alt={title}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hero;
